import * as React from 'react';
import {useNavigate} from 'react-router-dom';

import {Context_role} from '../../../context/rolesStore';
import {Context} from '../../../context/dataStore';
import {AnimatedEllipsis} from '../../../components';
import {getUniqueOrgData} from '../../../utils/utils';
import {ADMIN_ROLE, SUBMITTER_ROLE, EDITOR_ROLE, EM_ROLE, INVALID_ROLE, ROLE_TO_NAME} from '../../../constants/global';
import {CB_LOGIN} from '../../../constants/events';

import './Home.scss';

/**
 * When a user logs into our app with access to CB but not BFCP new asc solution, it takes to empty page
 * that gives warning:
 * 'Maximum update depth exceeded. This can happen when a component calls setState inside React.useEffect,
 * but React.useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.'
 */
const Home = () => {
  let navigate = useNavigate();
  const {decodePayload, getRole, checkInstitution, dispatcher, state: {newroles, institution, orgid_roles}} = React.useContext(Context_role);
  const {getOrganizations, dispatch, state: {orgData, metaDataAboutUser}, postEvents} = React.useContext(Context);

  React.useEffect(() => {
    const roles = decodePayload(cb.core.iam.getJWTToken()).cb.ro||[];
    getRole(roles);
    checkInstitution(roles);
    dispatcher({type: 'GET_ORGID_ROLES', payload: roles});
  }, [checkInstitution, decodePayload, dispatcher, getRole]);

  React.useEffect(() => {
    let isCurrent = true;
    const onLoad = async () => {
     await getOrganizations();
    };
    if(isCurrent && getOrganizations) {
      onLoad();
    }
    return() => isCurrent = false;
  }, [getOrganizations]);

  //check for HDC ADMIN role only!
  const decodeToken = decodePayload(cb.core.iam.getJWTToken());
  if(newroles[0]===ADMIN_ROLE) {
    sendEvent(decodeToken.cb, 'ADMIN', postEvents);
    navigate("/adminpage");
  } 
  if(newroles[0]===EM_ROLE) {
    //Only check institution[2]
    if(institution[2]===1) {
      if(orgData && orgData.length > 0) {
        const unique_org = getUniqueOrgData({orgid_roles, orgData, newrole:newroles[0]});
        dispatch({type:'UPDATE_METADATA', payload: {...metaDataAboutUser, orgName: orgData[0].org_name, orgId: orgData[0].org_id, org_role: newroles[0], legalNotice: false}});
        if(unique_org===undefined || unique_org.org_id===undefined) {
          return <div className='centerEllipsis'><AnimatedEllipsis /></div>;
        }
        sendEvent(decodeToken.cb, 'EM', postEvents);
        navigate(`/organizations/${unique_org.org_id}/categories/${0}/${EM_ROLE}`);
      } 
      else {
        return <div className='centerEllipsis'><AnimatedEllipsis /></div>;
      }
    }
    if(institution[2] > 1) {
      sendEvent(decodeToken.cb, 'EM', postEvents);
      navigate("/bfcp-select-organization", {oids: institution});
    }
  } 
  if(newroles[0]===SUBMITTER_ROLE) {
    // check for HDC SUBMITTER - ONE INSTITUITON
    if(institution[0] ===1 && institution[1] ===0) {
      if(orgData && orgData.length > 0) {
        const unique_org = getUniqueOrgData({orgid_roles, orgData, newrole:newroles[0]});
        dispatch({type:'UPDATE_METADATA', payload: {...metaDataAboutUser, orgName: orgData[0].org_name, orgId: orgData[0].org_id, org_role: newroles[0], legalNotice: false}});
        if(unique_org===undefined || unique_org.org_id===undefined) {
          return <div className='centerEllipsis'><AnimatedEllipsis /></div>;
        }
        sendEvent(decodeToken.cb, 'SUBMITTER', postEvents);
        navigate(`/organizations/${unique_org.org_id}/categories/${0}/${SUBMITTER_ROLE}`);
      } 
      else {
        return <div className='centerEllipsis'><AnimatedEllipsis /></div>;
      }
    }
    // check for HOME HDC SUBMITTER - MULTIPLE INSTITUITONS OF DIFFERENT ROLES
    if(institution[0] >= 1 && institution[1] >= 1) {
      sendEvent(decodeToken.cb, 'SUBMITTER', postEvents);
      navigate("/bfcp-select-organization");
    }
    // check for HOME HDC SUBMITTER - MULTIPLE INSTITUITONS OF SAME ROLE
    if(institution[0] > 1 && institution[1] ===0) {
      sendEvent(decodeToken.cb, 'SUBMITTER', postEvents);
      navigate("/bfcp-select-organization", {oids: institution});
    }
  } 
  if(newroles[0]===EDITOR_ROLE) {
    // check for HOME HDC EDITTER - ONE INSTITUITON
    
    if(institution[1] ===1 && institution[0] ===0) {
      if(orgData && orgData.length > 0) {
        const unique_org = getUniqueOrgData({orgid_roles, orgData, newrole:newroles[0]});
        dispatch({type:'UPDATE_METADATA', payload: {...metaDataAboutUser, orgName: orgData[0].org_name, orgId: orgData[0].org_id, org_role: newroles[0], legalNotice: false}});
        if(unique_org===undefined || unique_org.org_id===undefined) {
          return <div className='centerEllipsis'><AnimatedEllipsis /></div>;
        }
        sendEvent(decodeToken.cb, 'EDITOR', postEvents);
        navigate(`/organizations/${unique_org.org_id}/categories/${0}/${EDITOR_ROLE}`);
      } else {
        return <div className='centerEllipsis'><AnimatedEllipsis /></div>;
      }
    }
    // check for HOME HDC EDITTER - MULTIPLE INSTITUITONS OF DIFFERENT ROLES
    if(institution[0] >= 1 && institution[1] >= 1) {
      sendEvent(decodeToken.cb, 'EDITOR', postEvents);
      navigate("/bfcp-select-organization", {oids: institution});
    }
    // check for HOME HDC EDITTER - MULTIPLE INSTITUITONS OF SAME ROLE
    if(institution[1] > 1 && institution[0] ===0) {
      sendEvent(decodeToken.cb, 'EDITOR', postEvents);
      navigate("/bfcp-select-organization", {oids: institution});
    }
  } 
  if(newroles[0]===INVALID_ROLE) {
    navigate("/invalid");
  } 
  return <div className='centerEllipsis'><AnimatedEllipsis /></div>;
};

const sendEvent = (userInfo, role, postEvents) => {
  if(Object.keys(userInfo).length!==0){
      const roles = userInfo.ro;
      const rolesMap = roles.reduce((accu, curr) => {
        const {rid, oid} = curr;
        if (!accu[rid]) {
          accu[rid] = [];
        }
        accu[rid].push(Number(oid));
        return accu;
      }, {});

      const rolesAndOrgsArray = Object.keys(rolesMap)
        .filter(k => !!ROLE_TO_NAME[k])
        .map(k => {
          const role = ROLE_TO_NAME[k];
          if(role === 'ADMIN') {
            return { role };
          }
          else {
            return {
              role,
              orgIds: rolesMap[k]
            };
          }
        });
      const event_type = CB_LOGIN;
      const last_updated_at = new Date();
      const event_data = { rolesAndOrgsArray, userName: userInfo.un, role: role, email: userInfo.em, loginTime: last_updated_at, ns: userInfo.ns};
      const last_updated_by = userInfo.un;
      const postData = {event_type, event_data, last_updated_at, last_updated_by};
      postEvents(postData);
    }
};

export default Home;